<template>
  <v-app id="searchNegativeBalance">
    <v-main>
      <v-container fluid>
        <v-card flat>

          <v-row cols="12" no-gutter dense>
            <v-col cols="2" class="ml-4 pt-4">
              <h3>Negative Balance Report</h3>
            </v-col>    
            <v-col cols="3" class="ml-4">
              <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail />
            </v-col>
            <v-col cols="3" class="pt-4 ml-8">
              <v-btn small plain v-on:click="expandAll()">expand all</v-btn>                          
              <v-btn small plain v-on:click="collapseAll()">collapse all</v-btn>
            </v-col>
          </v-row>  

          <v-data-table 
              :items="items" 
              :items-per-page="50" 
              :footer-props="{'items-per-page-options': [10, 20, 50, 100, 200, 300, 500]}"
              :headers="headers"
              :loading="loading"
              :search="search"
              loading-text="Loading... Please wait. This may take up to a minute."
              :expanded.sync="expanded"
              show-expand
              item-key="huov_code">
            <template v-slot:expanded-item="{  headers, item }">               
              <td :colspan="headers.length" class="py-2">
                <table  style="width: 100%; border-collapse: collapse;" v-if="item.nott.length!==0">
                  <tr v-for="(note, idx) in item.nott" :key="note.nott_dt" :class="{'bg-gray': !isEven(idx)}">
                    <td style="width: 150px; padding-left: 20px; vertical-align: top;" class="py-2">{{ note.nott_dt }}</td>
                    <td style="width: 100px; vertical-align: top;" class="py-2">{{ note.nott_gebr_code }}</td>
                    <td class="py-2" style="vertical-align: top;"><span v-html="note.nott_tekst"></span></td>                    
                  </tr>
                </table>
                <table v-else style="width: 100%; border-collapse: collapse;"><em style="width: 150px; padding-left: 20px; vertical-align: top;" class="py-2">No data to display</em></table>
              </td>                      
            </template>

            <template v-slot:item.huov_code = "{item}">   
              <td @click="$router.open('/huov/onHuov/' + item.huov_encrid)"><a> {{item.huov_code}} </a></td>
            </template>

            <template v-slot:item.hust_code = "{item}">   
              <td><v-chip :color=item.hust_kleur class="hust-code">{{item.hust_code}}</v-chip></td>
            </template>

            <template v-slot:item.huis_code = "{item}">   
              <td @click="$router.open('/huis/onHuis/' + item.huis_encrid)"><a> {{item.huis_code}} </a></td>
            </template>            

            <template v-slot:item.huov_dt = "{item}">   
              <td>{{ $moment(item.huov_dt).format("DD-MMM-YYYY HH:mm") }}</td>   
            </template>           

            <template v-slot:item.huov_van_dat = "{item}">   
              <td>{{ $moment(item.huov_van_dat).format("DD-MMM-YYYY") }}</td>   
            </template>     

            <template v-slot:item.klnt_naam = "{item}">   
              <td @click="$router.open('/klnt/onKlnt/' + item.klnt_encrid)"><a> {{item.klnt_naam}} </a></td>
            </template>     

            <template v-slot:item.balance = "{item}">     
              <td class="amount">
                <span>{{item.balance | nl_numberformat }}</span>
              </td>
            </template> 

            <template v-slot:item.remark = "{item}">                   
              <td align="center">
                <v-badge v-if="item.nott.length!==0" :content="item.nott.length">
                   <v-icon @click="nott(item.huov_encrid);">mdi-clipboard-text-outline</v-icon>
                </v-badge>
                <v-icon v-else @click="nott(item.huov_encrid);">mdi-clipboard-text-outline</v-icon>
              </td>            
            </template> 

          </v-data-table>       

        </v-card>
      </v-container>
    </v-main>

    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
    <nott ref="nott"></nott>

  </v-app>
</template>

<script>

  import navBar from "@/components/ui/navbars/navbar.vue";
  import nott from "@/components/nott";
  import mxnumberformat from '@/mixins/amount_nl';

  import {bus} from "../../main";

  export default {
    components: {
      navBar,
      nott
    },
    data() {
      return {
        items: [],
        search: '',
        expanded: [],
        loading: true,
        headers: [
          { text: 'Id', value: 'huov_code' },
          { text: 'Status', value: 'hust_code' },
          { text: 'Acco', value: 'huis_code' },
          { text: 'Booking', value: 'huov_dt' },
          { text: 'Arrival', value: 'huov_van_dat' },
          { text: 'Guest', value: 'klnt_naam' },
          { text: 'Crt/Lang', value: 'klnt_landtaal' },
          { text: 'Partner', value: 'inpt_naam' },
          { text: 'Balance €', value: 'balance', align: "end", sortable: false},
          { text: 'Remark(s)', value: 'remark', align: 'center', sortable: false},
          { text: '', value: 'data-table-expand', sortable: false },
        ]
      }
    },
    mixins:[mxnumberformat],  
    created(){
      bus.$on("addNote", (data) => {
        if(data!==0){
          this.getNegativeBalances();
        }
      });   
    },
    mounted() {
      this.getNegativeBalances();
    },
    methods: {
      getNegativeBalances(){
        console.log('start getNegativeBalance');
        this.loading = true
        this.$axios
        .post("ares/json/ares/huov/searchNegativeBalance.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchNegativeBalance"
          },
          searchNegativeBalance: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {            
            this.items = res.data.searchNegativeBalance;
          }
        })
        .finally(() => {
          this.loading = false;
        });
      },
      nott(huov_encrid) {
        this.$refs.nott.open("huov", huov_encrid, "Negative balance");
      },
      collapseAll() {
        this.expanded = [];
      }, 
      expandAll(){
        this.items.filter(e => e.nott.length !==0 ? this.expanded.push(e) : false);
      },          
      isEven (idx){
        return (idx%2 === 0)
      }
    }
  };

</script> 

<style scoped>
  .indent{
    text-align: center;
  }
  .encapsulated_td{
    border-top: 10px solid transparent;
  }
  .amount{
    text-align: end;
  }
  .hust-code{
    color:white;
  }
  .bg-gray {
    background-color: #e8e8e8 !important;
  }
</style>
